import React, { memo } from "react";
import type { CUIImageProps } from "./types";
import { Icon } from "components/src/components/Icon/Icon";
import { TeamLogo } from "components-sbk/src/components/TeamLogo/TeamLogo";
import { TeamMatchup } from "components-sbk/src/components/TeamMatchup/TeamMatchup";
import parseIconString, {
  IconStringReturnType,
  isValidIconString,
} from "components/src/utils/parseIconString";

export const CUIImage = memo<CUIImageProps>(({ name, ...rest }: CUIImageProps) => {

  let _name: IconStringReturnType = null;
  if (isValidIconString(name)) {
    _name = parseIconString(name) as IconStringReturnType;
  } else {
    return null;
  }
  if (!_name) return null;
  if (_name && Array.isArray(_name) && _name?.length === 2)
    return (
      <TeamMatchup
        firstTeam={_name?.at(0).name}
        secondTeam={_name.at(1).name}
        {...rest}
      />
    );
  if (typeof _name === "object" && _name?.isTeam)
    return <TeamLogo name={_name?.name} size="xl" {...rest} />;
  return <Icon size="xl" name={_name?.name} {...rest} />;
});

CUIImage.displayName = "CUIImage";